<script>
    /**
     * The background color of the button
     */
     export let backgroundColor = undefined;
    /**
     * The font color of the button
     */
    export let fontColor = undefined;
    /**
     * Whether the button is active or currently selected
     */
    export let isActive = false;
    /**
     * Any additional style classes for the button
     */
    export let extraClasses = ["btn-light"];
    /**
     * The type of button (form submit, button, reset)
     */
    export let type = "button";

    $: classes = ["btn", "btn-custom"].concat(extraClasses);
    $: bgColorStyle = backgroundColor ? `background-color: ${backgroundColor};` : undefined;
    $: fontColorStyle = fontColor ? `color: ${fontColor};` : undefined; 
    $: style = bgColorStyle && fontColorStyle ? bgColorStyle + " " + fontColorStyle :
        bgColorStyle ? bgColorStyle :
        fontColorStyle ? fontColorStyle :
        undefined;
</script>

<button type={type}
    class={classes.join(" ")}
    class:active={isActive}
    style={style ? style : ""}
    on:click
    on:dblclick
    on:blur
    on:focus
    on:focusin
    on:focusout
>
    <slot></slot>
</button>

<style>
    button {
        font-size: 1rem;
    }

    .btn {
        margin-bottom: .35em;
        border-radius: 0px;
    }

    .btn-light {
        background-color: #ebebeb;
    }

    .btn-custom {
        border: 1px solid #fff;
    }

    .btn-light.active {
        box-shadow: 0 0 0 0.1rem rgba(88, 89, 91, 0.5);
    }

    .btn-light:focus, .btn-light:hover {
        background-color: #bac5ce !important;
    }
</style>